import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GamesSharedModule } from '@games/games-shared/games-shared.module';
import { GameButtonComponent } from '@new-core/components/buttons-game/game-button/game-button.component';
import { AnswerEntryFormComponent } from '@new-core/components/inputs-gi/answer-entry-form/answer-entry-form.component';
import { GameInputComponent } from '@new-core/components/inputs-gi/game-input/game-input.component';
import { TranslateModule } from '@ngx-translate/core';
import {
  ButtonModule,
  DefaultImageModule,
  FitTextModule,
  FormFieldModule,
  MarkInputModule,
  RectModule,
  TimerModule,
} from '@shared/components/games';
import { CalculatorModule } from '@shared/components/games/calculator/calculator.module';
import { AnswerResultFormModule } from '../../../new-core/components/game-forms/answer-result-form/answer-result-form.module';
import { ResultFormBgModule } from '../../../new-core/components/game-forms/result-form-bg/result-form-bg.module';
import { MenarAbacusToolModule } from '../tools/menar-abacus-tool/menar-abacus-tool.module';
import { MenarBackgroundHeroComponent } from './multi-controller/menar-background-hero/menar-background-hero.component';
import { MultiControllerComponent } from './multi-controller/multi-controller.component';
import { MultiExampleColumnComponent } from './multi-controller/multi-example-column/multi-example-column.component';
import { MultiExampleComponent } from './multi-controller/multi-example/multi-example.component';
import { MultiScreenPlayComponent } from './multi-controller/screens/multi-screen-play/multi-screen-play.component';
import { MultiScreenResultsComponent } from './multi-controller/screens/multi-screen-results/multi-screen-results.component';
import { MultiCorrectAnswerPreviewComponent } from './multi-preview/multi-answer-preview/multi-answer-preview.component';
import { MultiExamplePreviewComponent } from './multi-preview/multi-example-preview/multi-example-preview.component';
import { MultiParametersPreviewComponent } from './multi-preview/multi-parameters-preview/multi-parameters-preview.component';
import { MultiUserAnswerPreviewComponent } from './multi-preview/multi-user-answer-preview/multi-user-answer-preview.component';
import { MultiSettingsComponent } from './multi-settings/multi-settings.component';
import { CalculatorLayoutComponent } from '@shared/components/games/input-layouts/calculator-layout/calculator-layout.component';
import { SafePipeModule } from '../../../crm/@Mindskills/pipes/safe-pipe';

@NgModule({
  declarations: [
    MultiControllerComponent,
    MultiSettingsComponent,
    MultiExamplePreviewComponent,
    MultiCorrectAnswerPreviewComponent,
    MultiUserAnswerPreviewComponent,
    MultiParametersPreviewComponent,
    MultiExampleColumnComponent,
    MultiExampleComponent,
    MultiScreenPlayComponent,
    MultiScreenResultsComponent,
  ],
  exports: [
    MultiControllerComponent,
    MultiSettingsComponent,
    MultiExamplePreviewComponent,
    MultiCorrectAnswerPreviewComponent,
    MultiUserAnswerPreviewComponent,
    MultiParametersPreviewComponent,
  ],
  imports: [
    CommonModule,
    CalculatorModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    DefaultImageModule,
    FormFieldModule,
    MarkInputModule,
    ButtonModule,
    FitTextModule,
    MenarAbacusToolModule,
    RectModule,
    TimerModule,
    GameInputComponent,
    GameButtonComponent,
    ResultFormBgModule,
    AnswerEntryFormComponent,
    AnswerResultFormModule,
    GamesSharedModule,
    MenarBackgroundHeroComponent,
    CalculatorLayoutComponent,
    SafePipeModule,
  ],
})
export class MultiModule {}
